"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlightList = void 0;
const react_1 = __importDefault(require("react"));
const classFunctions_1 = require("../../../utils/classFunctions");
const Table_1 = require("../../Table");
const utils_1 = require("./utils");
require("./index.scss");
const className = 'flight-list';
const FlightList = (props) => {
    const { tableColumns, tableData, sortBy, sortOrder, setSort, setSelectedRows, highlightFlightId, highlightSequenceFlightId, modificators, } = props;
    const classNames = (0, classFunctions_1.getClassNames)(className, modificators);
    const tableModificators = (0, utils_1.useTableModificators)(highlightFlightId, highlightSequenceFlightId);
    return (react_1.default.createElement("div", { className: classNames },
        react_1.default.createElement(Table_1.Table, { columns: tableColumns, data: tableData, defaultSortBy: sortBy, defaultSortOrder: sortOrder, manualSortBy: true, setSort: setSort, setSelectedRows: setSelectedRows, tableModificators: tableModificators })));
};
exports.FlightList = FlightList;
//# sourceMappingURL=index.js.map